import styled from "@emotion/styled";
import { Box, Button, Dialog, Typography } from "@mui/material";
import React from "react";
import ALertImage from "../assets/Image/exclamatory.png";

const AlertBox = ({
  open = false,
  handleClose = () => {},
  title = "title",
  message = "message",
  handleSubmit = () => null,
}) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <Container>
        <Image src={ALertImage} />
        <Typography fontWeight={600}>{title}</Typography>

        <Typography fontSize={14} color="gray">
          {message}
        </Typography>
        <ActionContainer>
          <ActionBtn variant="outlined" fullWidth onClick={handleSubmit}>
            Yes
          </ActionBtn>
          <ActionBtn variant="outlined" fullWidth onClick={handleClose}>
            No
          </ActionBtn>
        </ActionContainer>
      </Container>
    </Dialog>
  );
};

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 10,
  padding: "2rem",
  alignItems: "center",
}));

const Image = styled("img")(({ theme }) => ({
  width: 50,
  height: 50,
}));

const ActionContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  width: "100%",
}));
const ActionBtn = styled(Button)(({ theme }) => ({
  borderColor: "gray",
  color: "gray",
}));

export default AlertBox;
